import React from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {PageBrowseSimple} from "./pages/PageBrowseSimple";
import {PageView} from "./pages/PageView";
import {PageSearch} from "./pages/PageSearch";
import {PageUpload} from "./pages/PageUpload";

export function MainRouting() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path={"/browse"} component={PageBrowseSimple}/>
                <Route path={"/search"} component={PageSearch}/>
                <Route path={"/view/:resourceId"} component={PageView}/>
                <Route path={"/upload"} component={PageUpload}/>
                <Route path={""} component={PageBrowseSimple}/>
            </Switch>
        </BrowserRouter>
    );
}
